import { ShortcutOptionType } from '@home/components/RangePicker/_config';
import type { MomentTimeType, ServerTimeType } from '../types';
import { DBO_TM } from '@op/utils/format';
import moment from 'moment';

export const competitorOptions = [
  { text: 'Launch 1 Day', value: '1' },
  { text: 'Launch 7 Days', value: '7' },
  { text: 'Launch 30 Days', value: '30' },
  { text: 'Launch 60 Days', value: '60' },
  { text: 'Launch 90 Days', value: '90' },
  { text: 'Launch 180 Days', value: '180' },
  { text: 'Launch 365 Days', value: '365' },
  { text: 'Launch to Date', value: 'all' },
];

export const versionOptions = [
  { text: 'The Launch Day 1', value: '1-day' },
  { text: 'The Launch Day 7', value: '7-week' },
  { text: 'The Launch Day 30', value: '30-month' },
];

export const dayToDaily: {
  [key: string]: ServerTimeType;
} = {
  '1day': 'daily',
  '3days': 'daily',
  '7days': 'daily',
  '30days': 'daily',
  date: 'daily',
  hour: 'hourly',
  week: 'weekly',
  month: 'monthly',
};
export const dailyToDay: { [key: string]: MomentTimeType; } = {
  daily: 'date',
  hourly: 'hour',
  weekly: 'week',
  monthly: 'month',
};

export const sameDateFormat: { [key: string]: MomentTimeType; } = {
  daily: 'date',
  hourly: 'hour',
  weekly: 'date',
  monthly: 'month',
};

export const dailyToRenderDay: { [key: string]: string; } = {
  daily: 'Day',
  hourly: 'Hour',
  weekly: 'Week',
  monthly: 'Month',
};

export const dailyFormat: { [key: string]: string; } = {
  daily: 'YYYY-MM-DD',
  hourly: 'YYYY-MM-DD HH:mm:ss',
  weekly: 'YYYY-MM-DD',
  monthly: 'YYYY-MM',
};

export const defaultRangePickerValue = () => ({
  '1day': [DBO_TM.utc(), DBO_TM.utc()],
  '3days': [DBO_TM.utc().subtract(2, 'day'), DBO_TM.utc()],
  '7days': [DBO_TM.utc().subtract(6, 'day'), DBO_TM.utc()],
  '30days': [DBO_TM.utc().subtract(29, 'day'), DBO_TM.utc()],
  date: [DBO_TM.utc(), DBO_TM.utc()],
  week: [DBO_TM.utc().startOf('W'), DBO_TM.utc().endOf('W')],
  month: [DBO_TM.utc().startOf('M'), DBO_TM.utc().endOf('M')],
  hour: [
    DBO_TM.utc().startOf('day').startOf('hour'),
    DBO_TM.utc().endOf('day').endOf('hour'),
  ],
});

export const defaultGptRangePickerValue = () => ({
  '1day': [DBO_TM.utc().subtract(1, 'day'), DBO_TM.utc().subtract(1, 'day')],
  '3days': [DBO_TM.utc().subtract(3, 'day'), DBO_TM.utc().subtract(1, 'day')],
  '7days': [DBO_TM.utc().subtract(7, 'day'), DBO_TM.utc().subtract(1, 'day')],
  '30days': [
    DBO_TM.utc().subtract(30, 'day'),
    DBO_TM.utc().subtract(1, 'day'),
  ],
  date: [DBO_TM.utc().subtract(1, 'day'), DBO_TM.utc().subtract(1, 'day')],
  week: [
    DBO_TM.utc().subtract(1, 'day').startOf('week'),
    DBO_TM.utc().subtract(1, 'day').endOf('week'),
  ],
  month: [DBO_TM.utc().subtract(1, 'day'), DBO_TM.utc().subtract(1, 'day')],
  hour: [DBO_TM.utc().subtract(1, 'day'), DBO_TM.utc().subtract(1, 'day')],
});

export const START_OF_WEEK = 1;

// '12069', '1021'
export const dateWhiteUserList: string[] = [];

export const newOpinionOptionsMap = {
  '1day': { value: '1day', text: '1 Day', text_cn: '1天' },
  '3days': { value: '3days', text: '3 Days', text_cn: '3天' },
  '7days': { value: '7days', text: '7 Days', text_cn: '7天' },
  '30days': { value: '30days', text: '30 Days', text_cn: '30天' },
  hour: { value: 'hour', text: 'By Hour', text_cn: '按小时' },
  date: { value: 'date', text: 'By Day', text_cn: '按日' },
  week: { value: 'week', text: 'By Week', text_cn: '按周' },
  month: { value: 'month', text: 'By Month', text_cn: '按月' },
  year: { value: 'year', text: 'By Year', text_cn: '按年' },
};

export const opinionOptionsMap = {
  '1day': { value: '1day', text: '1 Day', text_cn: '1天' },
  '3days': { value: '3days', text: '3 Days', text_cn: '3天' },
  '7days': { value: '7days', text: '7 Days', text_cn: '7天' },
  '30days': { value: '30days', text: '30 Days', text_cn: '30天' },
  hour: { value: 'hour', text: 'Hour', text_cn: '时' },
  date: { value: 'date', text: 'Day', text_cn: '日' },
  week: { value: 'week', text: 'Week', text_cn: '周' },
  month: { value: 'month', text: 'Month', text_cn: '月' },
  year: { value: 'year', text: 'Year', text_cn: '年' },
};

function getTodayTime() {
  // DBO_TM.utc();
  return {
    s: DBO_TM.utc(),
    e: DBO_TM.utc(),
  };
}

export function getHourMap() {
  return {
    hour: [
      {
        name: 'Last 1 hour',
        nameCN: '最近1小时',
        onClick: () => {
          const { s, e } = getTodayTime();
          return [
            s.subtract(1, 'hour').startOf('hour'),
            e.subtract(1, 'hour').endOf('hour'),
          ];
        },
      },
      {
        name: 'Last 6 hour',
        nameCN: '最近6小时',
        onClick: () => {
          const { s, e } = getTodayTime();
          return [
            s.subtract(6, 'hour').startOf('hour'),
            e.subtract(1, 'hour').endOf('hour'),
          ];
        },
      },
      {
        name: 'Last 12 hour',
        nameCN: '最近12小时',
        onClick: () => {
          const { s, e } = getTodayTime();
          return [
            s.subtract(12, 'hour').startOf('hour'),
            e.subtract(1, 'hour').endOf('hour'),
          ];
        },
      },
      {
        name: 'Last 24 hour',
        nameCN: '最近24小时',
        onClick: () => {
          const { s, e } = getTodayTime();
          return [
            s.subtract(24, 'hour').startOf('hour'),
            e.subtract(1, 'hour').endOf('hour'),
          ];
        },
      },
    ],
  };
}

// startOfTime和latestDate，不是所有地方都需要，需要从外部传入参数
export const shortcutOption = (
  startOfTime: string,
  latestDate: any,
  releaseOfTime: string,
): ShortcutOptionType => {
  const { date, month, week } = latestDate;

  const latestDataObj = {
    name: 'Latest Data',
    nameCN: '最新数据',
  };
  const allOfTimeObj = {
    name: 'All of time',
    nameCN: '所有时间',
  };

  const releaseOfTimeObj = {
    name: 'Since Release',
    nameCN: '上线以来',
  };

  const latestDateData = {
    ...latestDataObj,
    onClick: () => [moment(date), moment(date)],
  };
  const latestWeekData = {
    ...latestDataObj,
    onClick: () => [moment(week).weekday(0), moment(week).weekday(6)],
  };
  const latestMonthData = {
    ...latestDataObj,
    onClick: () => [
      moment(month).subtract(0, 'month').startOf('month'),
      moment(month).subtract(0, 'month').endOf('month'),
    ],
  };

  const allDateOfTime = {
    ...allOfTimeObj,
    onClick: () => [moment(startOfTime), moment()],
  };
  const allWeekOfTime = {
    ...allOfTimeObj,
    onClick: () => [moment(startOfTime).startOf('week'), moment().weekday(6)],
  };
  const allMonthOfTime = {
    ...allOfTimeObj,
    onClick: () => [moment(startOfTime), moment().endOf('month')],
  };

  let dateArray = [
    {
      name: 'Last 7 Days',
      nameCN: '最近7天',
      onClick: () => [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      onClick: () => [moment().subtract(30, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      onClick: () => [moment().subtract(90, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      onClick: () => [moment().subtract(180, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      onClick: () => [moment().subtract(365, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => [moment().startOf('year'), moment()],
    },
    {
      ...releaseOfTimeObj,
      onClick: () => [moment(releaseOfTime), moment()],
    },
  ];

  let weekArray = [
    {
      name: 'Last 4 Weeks',
      nameCN: '最近4周',
      onClick: () => [moment().weekday(-7 * 4), moment().weekday(-1)],
    },
    {
      name: 'Last 12 Weeks',
      nameCN: '最近12周',
      onClick: () => [moment().weekday(-7 * 12), moment().weekday(-1)],
    },
    {
      name: 'Last 24 Weeks',
      nameCN: '最近24周',
      onClick: () => [moment().weekday(-7 * 24), moment().weekday(-1)],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => 
        // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
        [moment().startOf('year').startOf('week'), moment().weekday(6)]
      ,
    },
    {
      ...releaseOfTimeObj,
      onClick: () => [moment(releaseOfTime).startOf('week'), moment().weekday(6)],
    },
  ];

  let monthArray = [
    {
      name: 'Last 3 Months',
      nameCN: '最近3个月',
      onClick: () => [
        moment().subtract(3, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 6 Months',
      nameCN: '最近6个月',
      onClick: () => [
        moment().subtract(6, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 12 Months',
      nameCN: '最近12个月',
      onClick: () => [
        moment().subtract(12, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 24 Months',
      nameCN: '最近24个月',
      onClick: () => [
        moment().subtract(24, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => [moment().startOf('year'), moment().endOf('month')],
    },
    {
      ...releaseOfTimeObj,
      onClick: () => [moment(releaseOfTime), moment().endOf('month')],
    },
  ];

  if (JSON.stringify(latestDate) !== '{}') {
    dateArray = [latestDateData, ...dateArray];
    weekArray = [latestWeekData, ...weekArray];
    monthArray = [latestMonthData, ...monthArray];
  }
  if (startOfTime != '') {
    dateArray = [...dateArray, allDateOfTime];
    weekArray = [...weekArray, allWeekOfTime];
    monthArray = [...monthArray, allMonthOfTime];
  }

  return {
    ...getHourMap(),
    date: dateArray,
    week: weekArray,
    month: monthArray,
  };
};

export const timeRangeUserTranslate = {
  en: { selectTime: 'Select Hour' },
  cn: { selectTime: '选择小时' },
};
